/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Actors from 'components/Ensemble/Actors/Actors';
import Artistic from 'components/Ensemble/Artistic/Artistic';
import Band from 'components/Ensemble/Band/Band';
import Contributors from 'components/Ensemble/Contributors/Contributors';

import 'components/Ensemble/Ensemble.scss';

const content = {
  actors: Actors,
  artisticStab: Artistic,
  band: Band,
  contributors: Contributors,
};

/**
 * This is the Ensemble component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Ensemble({ type, title, ...props }) {
  const Block = content[type] ?? null;
  if (!Block) return null;

  function renderTitle() {
    if (!title) return null;
    return <h2>{title}</h2>;
  }

  return (
    <div className="block block-ensemble">
      {renderTitle()}
      <Block type={type} level={title ? 3 : 2} {...props} />
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Ensemble.propTypes = {
  type: PropTypes.oneOf(['actors', 'artisticStab', 'band', 'contributors'])
    .isRequired,
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Ensemble.defaultProps = {
  type: 'actors',
  title: null,
};

export default Ensemble;
